module.exports = __webpack_public_path__ + "img/Cutaways_house_3_a_tile.2a7be1e8.jpg";